import { render, staticRenderFns } from "./vue-video.vue?vue&type=template&id=2f3367fc&scoped=true&"
import script from "./vue-video.vue?vue&type=script&lang=js&"
export * from "./vue-video.vue?vue&type=script&lang=js&"
import style0 from "./vue-video.vue?vue&type=style&index=0&lang=css&"
import style1 from "./vue-video.vue?vue&type=style&index=1&id=2f3367fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3367fc",
  null
  
)

export default component.exports